import { useState } from "react";
import {
  MotionGrid as Grid,
  MotionFlex as Flex,
  MotionBox as Box,
} from "utils/motion";

import Text from "components/base/Text";
import Arrow from "components/icons/Arrow";
import Image from "components/base/Image";
import Link from "components/base/Link";
import Trans from "components/base/Trans";

const hoverVariants = {
  hover: { scale: 1.02, transition: { type: "tween", duration: 0.5 } },
  regular: { scale: 1, transition: { type: "tween", duration: 0.5 } },
};

const hoverTextVariantsNext = {
  hover: { x: "4%", transition: { type: "tween", duration: 0.5 } },
  regular: { x: 1, transition: { type: "tween", duration: 0.5 } },
};

const hoverTextVariantsPrevious = {
  hover: { x: "-4%", transition: { type: "tween", duration: 0.5 } },
  regular: { x: 1, transition: { type: "tween", duration: 0.5 } },
};

export default function NavFooter({
  next,
  previous,
  pathPrevious,
  pathNext,
  bgPrevious,
  bgNext,
}) {
  const [hoveringNext, setHoveringNext] = useState(false);
  const [hoveringPrevious, setHoveringPrevious] = useState(false);

  return (
    <Box
      width="100%"
      height={["600px", null, "300px"]}
      position="relative"
      bg="black.900"
    >
      <Grid
        templateColumns={["1fr", null, "1fr 1fr"]}
        height={["600px", null, "300px"]}
        style={{ overflow: "hidden" }}
      >
        <Box h="300px" style={{ overflow: "hidden" }}>
          <Box
            position="relative"
            variants={hoverVariants}
            animate={hoveringPrevious ? "hover" : "regular"}
            h="300px"
          >
            <Image src={bgPrevious} objectFit="cover" />
            <Box
              position="absolute"
              top={0}
              left={0}
              h="100%"
              w="100%"
              bg="linear-gradient(90deg, var(--chakra-colors-black-700) 0%, rgba(0,0,0,0) 80%)"
            />
          </Box>
        </Box>
        <Box position="relative" h="300px" style={{ overflow: "hidden" }}>
          <Box
            variants={hoverVariants}
            animate={hoveringNext ? "hover" : "regular"}
            h="300px"
          >
            <Image src={bgNext} objectFit="cover" />
            <Box
              position="absolute"
              top={0}
              left={0}
              h="100%"
              w="100%"
              bg="linear-gradient(-90deg, var(--chakra-colors-black-700) 0%, rgba(0,0,0,0) 80%)"
            />
          </Box>
        </Box>
      </Grid>
      <Grid
        templateColumns={["1fr", null, "1fr 1fr"]}
        position="absolute"
        top={0}
        height="100%"
        width="100%"
      >
        <Link
          href={pathPrevious}
          _hover={{ textDecoration: "none" }}
          _focus={{ boxShadow: "none" }}
        >
          <Flex
            style={{ position: "relative" }}
            h="100%"
            align="center"
            onHoverStart={() => setHoveringPrevious(true)}
            onHoverEnd={() => setHoveringPrevious(false)}
          >
            <Box
              px={[6, null, 20]}
              variants={hoverTextVariantsPrevious}
              animate={hoveringPrevious ? "hover" : "regular"}
            >
              <Text type="title_lg" color="white">
                {previous}
              </Text>
              <Flex alignItems="center">
                <Arrow style={{ transform: "rotate(180deg)" }} mb={1} mr={1} />
                <Text
                  color="primary"
                  type="title_xs"
                  _hover={{ textDecoration: "underline" }}
                >
                  <Trans id="LBL_CTA_PREVIOUS" />
                </Text>
              </Flex>
            </Box>
          </Flex>
        </Link>

        <Link
          href={pathNext}
          _hover={{ textDecoration: "none" }}
          _focus={{ boxShadow: "none" }}
        >
          <Flex
            style={{ position: "relative" }}
            align="center"
            justify="flex-end"
            h="100%"
            onHoverStart={() => setHoveringNext(true)}
            onHoverEnd={() => setHoveringNext(false)}
          >
            <Box
              px={[6, null, 20]}
              textAlign="right"
              variants={hoverTextVariantsNext}
              animate={hoveringNext ? "hover" : "regular"}
            >
              <Text type="title_lg" color="white">
                {next}
              </Text>
              <Flex alignItems="center" justifyContent="flex-end">
                <Text
                  color="primary"
                  type="title_xs"
                  _hover={{ textDecoration: "underline" }}
                >
                  <Trans id="LBL_CTA_NEXT" />
                </Text>
                <Arrow mt={1} mr={1} />
              </Flex>
            </Box>
          </Flex>
        </Link>
      </Grid>
    </Box>
  );
}
